import React from 'react';
import './DashboardCalendarPresenter.css';
import CustomDashboardCard from '../../../../common/components/CustomDashboardCard/CustomDashboardCard';
import DashboardCalendarDataController from '../../../../common/components/AllCalendars/DashboardCalendar/DashboardCalendarDataController';

interface IReporterProps {
  cardSize: {
    card_title?: string;
  };
}

const DashboardCalendarCalendarPresenter = ({ cardSize }: IReporterProps) => {
  return (
    <>
      <CustomDashboardCard cardSize={cardSize} isCalendar={true}>
        <DashboardCalendarDataController />
      </CustomDashboardCard>
    </>
  );
};

export default DashboardCalendarCalendarPresenter;
